import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { SeEmailComposeComponent } from "./email/se.email.compose.component";

@TypeManagerDecorator("s25-ng-se-email-page")
@Component({
    selector: "s25-ng-se-email-page",
    host: { class: "email-page" },
    template: `
        <header class="page-header">
            <h1 class="page-title">Compose</h1>
        </header>
        <s25-ng-se-email-compose />
    `,
    styles: `
        :host {
            display: block;
            padding: 1.5rem;
        }

        .page-header {
            margin-bottom: 1rem;
            padding-bottom: 1rem;
            border-bottom: 1px solid var(--color--border, #e5e7eb);
        }

        .page-title {
            font-size: 1.75rem;
            font-weight: 600;
            margin: 0 0 0.25rem 0;
        }
    `,
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SeEmailComposeComponent],
})
export class SeEmailPageComponent {}
